import { isAvailable, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

export const COMMERCIAL_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Commercial),
    list: ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Commercial),
    list: ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'],
  },
];
